import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { useAuthState } from 'state/useAuthState';

type UseLightningLayerEnabledResult = {
  showInternalLightningLayer: boolean;
  showExternalLightningLayer: boolean;

  /** True if any lightning layer is enabled (e.g., internal or external). */
  showLightningLayer: boolean;
  showLightningInternalOnlyLabel: boolean;
};

export const useLightningLayerEnabled = (): UseLightningLayerEnabledResult => {
  const {
    permissions: { isInternalUser, canViewInternalLightningLayer },
  } = useAuthState();

  const showExternalLightningLayerFlag = useReleaseFlag(
    'show_external_lightning_layer_in_frontend',
  );

  const showInternalLightningLayer =
    isInternalUser || canViewInternalLightningLayer;
  const showExternalLightningLayer =
    !isInternalUser &&
    !showInternalLightningLayer &&
    showExternalLightningLayerFlag;

  const showLightningLayer =
    showInternalLightningLayer || showExternalLightningLayer;
  const showLightningInternalOnlyLabel =
    showInternalLightningLayer && !showExternalLightningLayerFlag;

  return {
    showInternalLightningLayer,
    showExternalLightningLayer,
    showLightningLayer,
    showLightningInternalOnlyLabel,
  };
};
